export const translations = {
  es: {
    nav: {
      services: "Servicios",
      book: "Agendar",
      admin: "Admin",
      logout: "Salir",
    },
    hero: {
      eyebrow: "Reparación experta · a domicilio y en sitio",
      title_1: "Arreglamos lo que",
      title_2: "otros no pueden.",
      subtitle: "Teléfonos, tabletas, computadoras y consolas. Agenda tu cita en menos de un minuto.",
      cta_book: "Agendar cita",
      cta_services: "Ver servicios",
    },
    services: {
      label: "Qué reparamos",
      title: "Cuatro categorías. Cero excusas.",
      phone: "Teléfonos",
      phone_desc: "Pantallas, batería, cámara, puerto de carga, agua.",
      tablet: "Tabletas",
      tablet_desc: "iPad y Android. Pantalla, glass, botones, software.",
      computer: "Computadoras",
      computer_desc: "PC y Mac. Placa base, disco, memoria, virus, sistema.",
      console: "Consolas",
      console_desc: "PS, Xbox, Switch. HDMI, ventilador, lector, joysticks.",
    },
    process: {
      label: "Cómo funciona",
      title: "Tres pasos. Sin sorpresas.",
      step1: "Agenda",
      step1_desc: "Elige dispositivo, servicio y horario.",
      step2: "Diagnóstico",
      step2_desc: "Revisamos y cotizamos antes de reparar.",
      step3: "Reparación",
      step3_desc: "Trabajo garantizado, entrega en tiempo.",
    },
    booking: {
      title: "Agenda tu cita",
      subtitle: "Un formulario. Un correo de confirmación. Un técnico en camino.",
      device_type: "Tipo de dispositivo",
      device_brand: "Marca",
      device_model: "Modelo",
      issue: "Descripción del problema",
      issue_ph: "Ej. La pantalla no responde después de una caída…",
      service_type: "Tipo de servicio",
      at_home: "A domicilio",
      in_shop: "En sitio",
      address: "Dirección",
      address_ph: "Calle, número, colonia, ciudad",
      date: "Fecha",
      time: "Hora",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      submit: "Confirmar cita",
      submitting: "Agendando…",
      pick_date: "Selecciona una fecha",
      language_note: "Idioma para la confirmación",
      required: "Campo requerido",
      success_title: "¡Cita agendada!",
      success_desc: "Te enviamos un correo con los detalles.",
    },
    devices: {
      phone: "Teléfono",
      tablet: "Tableta",
      computer: "Computadora",
      console: "Consola",
    },
    admin: {
      title: "Panel de administración",
      subtitle: "Gestión de citas",
      login: "Ingresar con Google",
      total: "Total",
      pending: "Pendientes",
      confirmed: "Confirmadas",
      in_progress: "En curso",
      completed: "Completadas",
      cancelled: "Canceladas",
      customer: "Cliente",
      device: "Dispositivo",
      service: "Servicio",
      when: "Cuándo",
      status: "Estado",
      actions: "Acciones",
      technician: "Técnico",
      no_data: "Sin citas todavía.",
      only_owner: "Acceso exclusivo del propietario.",
    },
    footer: {
      tag: "Reparación honesta. Trabajo garantizado.",
    },
    confirm: {
      title: "Cita confirmada",
      ref: "Referencia",
      back: "Volver al inicio",
      book_another: "Agendar otra",
    },
  },
  en: {
    nav: {
      services: "Services",
      book: "Book",
      admin: "Admin",
      logout: "Logout",
    },
    hero: {
      eyebrow: "Expert repair · at home and in shop",
      title_1: "We fix what",
      title_2: "others can't.",
      subtitle: "Phones, tablets, computers, and consoles. Book your appointment in under a minute.",
      cta_book: "Book appointment",
      cta_services: "See services",
    },
    services: {
      label: "What we fix",
      title: "Four categories. Zero excuses.",
      phone: "Phones",
      phone_desc: "Screens, battery, camera, charging port, water damage.",
      tablet: "Tablets",
      tablet_desc: "iPad and Android. Screen, glass, buttons, software.",
      computer: "Computers",
      computer_desc: "PC and Mac. Motherboard, disk, memory, virus, OS.",
      console: "Consoles",
      console_desc: "PS, Xbox, Switch. HDMI, fan, reader, joysticks.",
    },
    process: {
      label: "How it works",
      title: "Three steps. No surprises.",
      step1: "Book",
      step1_desc: "Pick device, service, and time slot.",
      step2: "Diagnose",
      step2_desc: "We inspect and quote before repairing.",
      step3: "Repair",
      step3_desc: "Guaranteed work, delivered on time.",
    },
    booking: {
      title: "Book your appointment",
      subtitle: "One form. One confirmation email. One tech on the way.",
      device_type: "Device type",
      device_brand: "Brand",
      device_model: "Model",
      issue: "Issue description",
      issue_ph: "E.g. The screen stopped responding after a drop…",
      service_type: "Service type",
      at_home: "At home",
      in_shop: "In shop",
      address: "Address",
      address_ph: "Street, number, neighborhood, city",
      date: "Date",
      time: "Time",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      submit: "Confirm appointment",
      submitting: "Booking…",
      pick_date: "Select a date",
      language_note: "Confirmation email language",
      required: "Required",
      success_title: "Appointment booked!",
      success_desc: "We sent you an email with the details.",
    },
    devices: {
      phone: "Phone",
      tablet: "Tablet",
      computer: "Computer",
      console: "Console",
    },
    admin: {
      title: "Admin panel",
      subtitle: "Appointments management",
      login: "Sign in with Google",
      total: "Total",
      pending: "Pending",
      confirmed: "Confirmed",
      in_progress: "In progress",
      completed: "Completed",
      cancelled: "Cancelled",
      customer: "Customer",
      device: "Device",
      service: "Service",
      when: "When",
      status: "Status",
      actions: "Actions",
      technician: "Technician",
      no_data: "No appointments yet.",
      only_owner: "Owner-only access.",
    },
    footer: {
      tag: "Honest repair. Guaranteed work.",
    },
    confirm: {
      title: "Appointment confirmed",
      ref: "Reference",
      back: "Back to home",
      book_another: "Book another",
    },
  },
};

export const TIME_SLOTS = [
  "09:00", "10:00", "11:00", "12:00",
  "13:00", "14:00", "15:00", "16:00", "17:00", "18:00",
];
